module.exports = __webpack_public_path__ + "static/media/daytime.ad343ff6.svg";